import addDays from "date-fns/addDays";
import startOfISOWeek from "date-fns/startOfISOWeek";
import { useCallback, useState } from "react";

const useWeek = () => {
  const [weekStart, setWeekStart] = useState(() => startOfISOWeek(new Date()));

  // Exclusive end (start of next Monday) — used by the date switcher which
  // calls subMilliseconds(end, 1) to display the last day of the week.
  const weekEnd = addDays(weekStart, 7);

  const onPrevClick = useCallback(() => {
    setWeekStart((prev) => addDays(prev, -7));
  }, []);

  const onNextClick = useCallback(() => {
    setWeekStart((prev) => addDays(prev, 7));
  }, []);

  return { weekStart, weekEnd, onPrevClick, onNextClick };
};

export default useWeek;
